import { usePpaScopeHydration } from 'hooks/ppa/usePpaScopeHydration';

/** Invisible helper that restores PPA scope on non-home PPA routes. */
const PpaScopeHydrator = () => {
    usePpaScopeHydration();
    return null;
};

export default PpaScopeHydrator;
